import api from "@/lib/api";

// Ask the backend to scan a picked file for an invoice number AND total amount.
// Returns { invoiceNumber, amount } — both may be empty/null when nothing is
// found or the file isn't supported. Silently swallows errors so a failed scan
// never breaks the form.
export async function extractFromFile(file, extraHeaders = {}) {
  const empty = { invoiceNumber: "", amount: null };
  if (!file) return empty;
  const name = (file.name || "").toLowerCase();
  const ext = name.includes(".") ? name.split(".").pop() : "";
  if (!["pdf", "xlsx", "xlsm"].includes(ext)) return empty;
  try {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await api.post("/utils/extract-invoice-number", fd, {
      headers: { "Content-Type": "multipart/form-data", ...extraHeaders },
    });
    return {
      invoiceNumber: (data && data.invoice_number) || "",
      amount: data && data.amount != null ? Number(data.amount) : null,
    };
  } catch {
    return empty;
  }
}

// Back-compat wrapper so older imports still resolve to a string.
export async function extractInvoiceNumber(file, extraHeaders = {}) {
  const { invoiceNumber } = await extractFromFile(file, extraHeaders);
  return invoiceNumber;
}
